const Plugin = require("common/Plugin");
const LogonController = require("logon/LogonController");
const LogonView = require("logon/LogonView");
const LogonMessageView = require("logon/LogonMessageView");
const LogonHandler = require("logon/LogonHandler");
const LogonRequestFailureHandler = require("logon/LogonRequestFailureHandler");
const MainTOTPView = require("./MainTOTPView");
const MainTOTPController = require("./MainTOTPController");

const TOTPLogonPlugin = function() {
    const self = this;
    let $menuEntry;

    this.start = function() {
        const logonMessageView = new LogonMessageView();
        const logonView = new LogonView(false);
        const logonController = new LogonController(logonMessageView, logonView);
        const mfaHandler = new LogonHandler(new LogonRequestFailureHandler());

        logonController.registerHandler(mfaHandler, "8.0.1");

        self.registerController(logonController);
        self.addOptionsMenuEntry($.t("common::logoff.title"), logonController.logoffUser, 0).then(function(entry) {
            $menuEntry = entry;
        });

        const mainTOTPView = new MainTOTPView();
        const mainTOTPController = new MainTOTPController(mainTOTPView);
        self.registerController(mainTOTPController);
    };

    $(document).on("userauthenticated", function(event, session) {
        if ($menuEntry && $menuEntry.toggle) {
            $menuEntry.toggle(!session.isCertOnly);
        }
    });
};

TOTPLogonPlugin.prototype = Plugin;

module.exports = TOTPLogonPlugin;